import axios from "axios";
import { toast } from "react-toastify";
import client from "../../api/client";
import { safeClear, safeGet, safeRemove, safeSet } from "../../utils/safeStorage";

// A message for ANY login failure. Errors that never got an API reply (no network, a blocked
// request, a timeout) have no `response`, and showing only `response.data.message` meant the
// user saw nothing at all.
export const authErrorMessage = (error) => {
  const apiMessage = error?.response?.data?.message;
  if (apiMessage) return apiMessage;
  if (error?.response) return `Something went wrong (error ${error.response.status}). Please try again.`;
  if (error?.code === "ECONNABORTED") return "The request timed out. Please check your connection and try again.";
  if (error?.message === "Network Error") {
    return "We couldn't reach the server. Check your connection (and turn off any VPN, iCloud Private Relay or content blocker), then try again.";
  }
  return error?.message || "Something went wrong. Please try again.";
};

// Retry a request that got no reply at all (dropped mobile data, a flaky route, a
// request reset mid-flight). Anything the server actually answered is final.
const withNetworkRetry = async (request, retries = 2) => {
  for (let attempt = 0; ; attempt++) {
    try {
      return await request();
    } catch (error) {
      if (error?.response || attempt >= retries) throw error;
      await new Promise((resolve) => setTimeout(resolve, 1500 * (attempt + 1)));
    }
  }
};

export const fetchUserLocation = async (dispatch) => {
  try {
    const res = (await axios.get("https://ipinfo.io/json")).data;
    dispatch({
      type: "FETCHED_DATA",
      payload: res?.country,
    });
    return true;
  } catch (error) {
    console.log("error fetching user location", error?.response);
    return false;
  }
};
export const signupHandler = async (data, dispatch) => {
  dispatch({
    type: "LOADING",
  });
  try {
    const res = (await client.post("/auth/register", data)).data;

    if (res?.message === "validation error") {
      throw new Error("User already exists");
    }
    if (res) {
      toast.success(
        "Sign up successfully check your mail to verify your account"
      );
    }
    // localStorage.setItem("nd-rest-tkn", res.data.data?.token);
    // localStorage.setItem("userData", JSON.stringify(res.data.data?.user));
    // // localStorage.removeItem("setupStore");
    // client.defaults.headers.post["Content-Type"] = "application/json";
    // client.defaults.headers.Authorization = `Bearer ${res.data.data?.token}`;

    return true;
  } catch (error) {
    error?.response?.data?.errors[error?.response?.data?.errors]?.map((cur) => {
      return toast.error(cur);
    });

    toast.error(error?.response?.data?.message || error?.message);
    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });

    return false;
  }
};

export const forgottenpassword = async (data, dispatch) => {
  // return alert(data.otp, data.email);
  // console.log("data", data);
  dispatch({
    type: "LOADING",
  });
  try {
    await client.post("/api/v1/Auth/forgotPassword/", data);

    return true;
  } catch (error) {
    console.log("Error", error.response);
    alert(error?.response?.data?.message);
    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });

    return false;
  }
};
export const resendPassword = async (data, dispatch) => {
  // return alert(data.otp, data.email);
  // console.log("data", data);
  dispatch({
    type: "LOADING",
  });
  try {
    await client.post("/api/v1/Auth/resetPassword", data);

    return true;
  } catch (error) {
    console.log("Error", error.response);
    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });

    return false;
  }
};
export const verifyOTP = async (data, dispatch) => {
  // return alert(data.otp, data.email);

  dispatch({
    type: "LOADING",
  });
  try {
    await client.post(
      "/api/v1/Auth/verifyOtpCodePasswordReset",
      data
    );
    // localStorage.setItem("nd-rest-tkn", res.data.data?.token);
    // client.defaults.headers.post["Content-Type"] = "application/json";
    // client.defaults.headers.Authorization = `Bearer ${res.data.data?.token}`;
    // console.log("success", res.data);
    // dispatch({
    //   type: "SUCCESS",
    //   payload: res.data.data,
    // });
    return true;
  } catch (error) {
    console.log("Error", error.response);
    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });

    return false;
  }
};

export const signInHandler = async (data, dispatch) => {
  dispatch({
    type: "LOADING",
  });
  try {
    const res = (await withNetworkRetry(() => client.post("/auth/login", data))).data;
    // A blocker / captive portal / proxy can answer 200 with an HTML page instead of
    // our JSON. Without this check the token became the string "undefined" and the
    // user was silently bounced straight back to the login screen.
    if (!res?.token) {
      throw new Error("The server sent an unexpected response. Please try again, or switch networks.");
    }

    const persisted = safeSet("nd-rest-tkn", res.token);
    client.defaults.headers.post["Content-Type"] = "application/json";
    client.defaults.headers.Authorization = `Bearer ${res.token}`;
    toast.success("Login successful!");
    if (!persisted) {
      toast.info("Your browser is blocking saved logins, so you'll need to sign in again if you reload or close this page.");
    }
    dispatch({
      type: "SUCCESS",
      payload: {
        token: res.token,
      },
    });
    getCurrentUser(dispatch).then((ok) => {
      if (!ok) toast.error("You're signed in, but we couldn't load your account. Please try logging in again.");
    });
    return true;
  } catch (error) {
    toast.error(authErrorMessage(error));

    console.log("Error", error.response || error);

    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });
    return false;
  }
};
export const googleHandler = async (data, dispatch) => {
  dispatch({
    type: "LOADING",
  });
  try {
    const res = (await withNetworkRetry(() => client.post("/auth/google", data))).data;
    // A blocker / captive portal / proxy can answer 200 with an HTML page instead of
    // our JSON. Without this check the token became the string "undefined" and the
    // user was silently bounced straight back to the login screen.
    if (!res?.token) {
      throw new Error("The server sent an unexpected response. Please try again, or switch networks.");
    }

    const persisted = safeSet("nd-rest-tkn", res.token);
    client.defaults.headers.post["Content-Type"] = "application/json";
    client.defaults.headers.Authorization = `Bearer ${res.token}`;
    toast.success("Login successful!");
    if (!persisted) {
      toast.info("Your browser is blocking saved logins, so you'll need to sign in again if you reload or close this page.");
    }
    dispatch({
      type: "SUCCESS",
      payload: {
        token: res.token,
      },
    });
    getCurrentUser(dispatch).then((ok) => {
      if (!ok) toast.error("You're signed in, but we couldn't load your account. Please try logging in again.");
    });
    return true;
  } catch (error) {
    toast.error(authErrorMessage(error));

    console.log("Error", error.response || error);

    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });
    return false;
  }
};

export const UpdateUserInfo = async (data, dispatch) => {
  try {
    await client.post("/user/info/update", data);

    // localStorage.setItem("nd-rest-tkn", res.data.data?.token);
    // localStorage.setItem("userData", JSON.stringify(res.data.data));
    // dispatch({
    //   type: "SUCCESS",
    //   payload: res.data.data,
    // });
    getCurrentUser(dispatch);
    return true;
  } catch (error) {
    toast.error(error?.response?.data?.message || "something went wrong");
    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });
    return false;
  }
};
export const UpdateUserPassword = async (data, dispatch) => {
  try {
    await client.post("/user/password/update", data);

    getCurrentUser(dispatch);
    return true;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    dispatch({
      type: "ERROR",
      payload: error?.response?.data?.message,
    });
    return false;
  }
};

export const logoutHandler = (dispatch) => {
  dispatch({
    type: "LOGOUT",
  });
  safeClear();
  return true;
};

export const getCurrentUser = async (dispatch) => {
  const user = safeGet("userData");

  let token = safeGet("nd-rest-tkn");
  // A token saved as the literal text "undefined"/"null" (from a bad login response) is not a session.
  if (token === "undefined" || token === "null") {
    safeRemove("nd-rest-tkn");
    token = null;
  }

  client.defaults.headers.post["Content-Type"] = "application/json";
  client.defaults.headers.Authorization = `Bearer ${token}`;

  if (user || token) {
    let savedUser = null;
    try {
      savedUser = user ? JSON.parse(user) : null;
    } catch {
      safeRemove("userData"); // corrupt saved profile — it gets re-fetched just below
    }
    dispatch({
      type: "SUCCESS",
      payload: { user: savedUser, token: token },
    });
    try {
      const res = (await withNetworkRetry(() => client.get(`/user`))).data;
      if (!res || typeof res !== "object") throw new Error("Unexpected /user response");
      safeSet("userData", JSON.stringify(res));
      const payload = {
        user: res,
        token: token,
      };

      dispatch({
        type: "SUCCESS",
        payload: payload,
      });
      return true;
    } catch (error) {
      // Only a 401 means the session is really gone. A network blip, timeout or
      // 5xx used to land here too and wiped a perfectly valid login.
      if (error?.response?.status === 401) {
        logoutHandler(dispatch);
      }
      console.log("Couldn't get user", error);
    }
    return false;
  } else {
    logoutHandler(dispatch);
    return false;
  }
};
